import React, { useState, useMemo } from 'react';

import moment from 'moment';

import { Report } from '~/components';
import {
  DateTime,
  Autocomplete,
  MultiAutocomplete,
  RadioGroup,
  Select,
} from '~/components/Form';
import { PesquisaTabela } from '~/components/Form/v2';
import { t } from '~/helpers';

function RelRaizenErrologIntegracao() {
  const [open, setOpen] = useState(true);

  // const [tiporeport, setTiporeport] = useState(0);

  const [valuePosto, setValuePosto] = React.useState([]);

  const [valuetiporeport, setValueTiporeport] = React.useState('');

  const [valueStatusreport, setValueStatusreport] = React.useState('');

  // const [inputValueBico, setInputValueBico] = React.useState('');

  const orderoptions = [
    {
      value: 'EntradaComboio',
      label: t('s.relatorio.relraizenerrologintegracao.entradacomboio'),
    },
    {
      value: 'MovimentacaoComboio',
      label: t('s.relatorio.relraizenerrologintegracao.movimentacaocomboio'),
    },
    {
      value: 'MovimentacaoPosto',
      label: t('s.relatorio.relraizenerrologintegracao.movimentacaoposto'),
    },
    {
      value: 'Transferencia',
      label: t('s.relatorio.relraizenerrologintegracao.transferencia'),
    },
  ];

  const gerastatusoptions = [
    { value: 'N', label: t('s.geral.opcoes.naoenviado') },
    { value: 'S', label: t('s.geral.opcoes.liberadoenvio') },
    { value: 'P', label: t('s.geral.opcoes.pendente') },
    { value: 'E', label: t('s.geral.opcoes.enviado') },
    { value: 'C', label: t('s.geral.opcoes.cancelado') },
    { value: 'T', label: t('s.relatorio.geral.todos') },
  ];

  const start = moment()
    .subtract({ day: 7 })
    .set({ hour: 0, minute: 0, second: 0 });
  const end = moment().set({ hour: 23, minute: 59, second: 59 });

  const cellsUser = useMemo(
    () => [
      {
        id: 'codigousuario',
        label: t('s.cadastro.usuario.codigousuario'),
        filter: { type: 'text' },
      },
      {
        id: 'nomeusuario',
        label: t('s.cadastro.usuario.nomeusuario'),
        filter: { type: 'text' },
      },
    ],
    []
  );

  function handleSerializeForm(params) {
    const idPosto =
      valuePosto === 0 ? '' : valuePosto?.map((posto) => posto.idposto);

    const idTiporeport = valuetiporeport === '' ? '' : valuetiporeport;

    const idstatusreport = valueStatusreport === '' ? '' : valueStatusreport;

    return {
      ...params,
      idposto: idPosto,
      idTiporeport,
      idStatusreport: idstatusreport,
    };
  }

  return (
    <Report
      open={open}
      onClose={() => setOpen(false)}
      title={t('s.relatorio.relraizenerrologintegracao')}
      relatorio="raizenerrologintegracao"
      serialize={(param) => handleSerializeForm(param)}
      initials={{
        datahorainicial: start.format('DD/MM/YYYY HH:mm:ss'),
        datahorafinal: end.format('DD/MM/YYYY HH:mm:ss'),
        idtiporeport: 'MovimentacaoPosto',
        idstatusreport: 'T',
      }}
    >
      <DateTime
        label={t('s.geral.opcoes.datahorainicial')}
        name="datahorainicial"
        serialize={(value) =>
          value.set({ seconds: 0 }).format('DD/MM/YYYY HH:mm:ss')
        }
        time
      />

      <DateTime
        label={t('s.geral.opcoes.datahorafinal')}
        name="datahorafinal"
        serialize={(value) =>
          value.set({ seconds: 59 }).format('DD/MM/YYYY HH:mm:ss')
        }
        time
      />

      <MultiAutocomplete
        multiple
        name="idposto"
        label="codigonomeposto"
        url="postoscomboios"
        unique="idposto"
        title={t('s.geral.postocomboio')}
        hiddens={[{ name: 'codigonomeposto' }]}
        getValue={(value) => {
          // setValueBico(0);
          // setInputValueBico('');
          if (value[0]?.idposto !== null) {
            setValuePosto(value);
            // setBico(0);
            // setValueBico(0);
          } else {
            setValuePosto(0);
            // setBico(0);
            // setValueBico(0);
          }
        }}
      />

      <Select
        name="idtiporeport"
        variant="outlined"
        size="small"
        label={t('s.relatorio.abastecimento.tipoordenacao')}
        options={orderoptions}
        getValue={(value) => {
          setValueTiporeport(value);
        }}
      />

      <Select
        name="idstatusreport"
        variant="outlined"
        size="small"
        label={t(
          's.operacao.raizenerrologintegracao.tabelaraizenerrologintegracao'
        )}
        options={gerastatusoptions}
        getValue={(value) => {
          setValueStatusreport(value);
        }}
      />

      <RadioGroup
        name="formato"
        label={t('s.relatorio.geral.formato')}
        options={[
          { label: 'PDF', value: 'pdf' },
          { label: 'Excel', value: 'excel' },
        ]}
        defaultValue="pdf"
        serialize={(value) => value}
        row
      />
    </Report>
  );
}

export default RelRaizenErrologIntegracao;

/*
import React from 'react';

import moment from 'moment';
import * as Yup from 'yup';

import { Report } from '~/components';
import { Input } from '~/components/Form';
import { t } from '~/helpers';

export default function RelRaizenErrologIntegracao() {
  const [open, setOpen] = React.useState(true);

  // Initial date
  const datahorainicial = React.useMemo(
    () =>
      moment()
        .subtract({ day: 7 })
        .set({ hour: 0, minute: 0, second: 0 })
        .format('DD/MM/YYYY HH:mm:ss'),
    []
  );

  // Final date
  const datahorafinal = React.useMemo(
    () =>
      moment().set({ hour: 23, minute: 59, second: 59 }).format('DD/MM/YYYY'),
    []
  );

  // Close modal
  const handleOnClose = React.useCallback(() => setOpen(false), []);

  // Format data before sending
  const handleBeforeSending = React.useCallback((data) => {
    return data;
  }, []);

  // Form validation
  const handleFormValidation = React.useCallback(async (data) => {
    try {
      const schema = Yup.object().shape({
        id: Yup.string().required(),
      });

      await schema.validate(data, {
        abortEarly: false,
      });
    } catch (err) {
      const validationErrors = {};

      if (err instanceof Yup.ValidationError) {
        err.inner.forEach((error) => {
          validationErrors[error.path] = error.message.replace(
            `${error.path} `,
            ''
          );
        });

        // eslint-disable-next-line no-throw-literal
        throw { validationErrors };
      }
    }
  }, []);

  return (
    <Report
      open={open}
      onClose={handleOnClose}
      title={t('RelRaizenErrologIntegracao')}
      relatorio="extratoproduto"
      serialize={handleBeforeSending}
      validate={handleFormValidation}
      initials={{ datahorainicial, datahorafinal }}
    >
      <Input name="id" label={t('s.relatorio.id')} />
    </Report>
  );
}



*/
